import * as CarModels from "../../models/car/car";
import * as Models from "../../models/commonModels";
import * as GarageVisitsModels from '../../models/garage-visits/garage-visits';
import * as DepoisteModels from "../../models/deposite/deposite";
import * as GarageModels from "../../models/garage/garage";
import * as TyreOrderModels from "../../models/tyre-order/tyre-order";


export class GarageVisitCreate {
  static readonly type = '[Ald-Anonymous] Garage Visit Create';
  constructor(public GarageVisit: Models.Request<GarageVisitsModels.GarageVisitModel>) { }
}

export class CheckCar {
  static readonly type = "[Ald-Anonymous] Get Car";
  constructor(public RegistrationNumber: Models.Request<string>) { }
}

export class GaragesGet {
  static readonly type = "[Ald-Anonymous] Garages Get";
  constructor(public Request: Models.RequestBase) { }
}

export class GaragePreviewGet {
  static readonly type = "[Ald-Anonymous] Garage Preview Get";
  constructor(public Garage: Models.RequestModel) { }
}

export class GetGarageBlockedDaysList {
  static readonly type = '[Ald-Anonymous]  GetGarageBlockedDaysList';
  constructor(public Search: GarageVisitsModels.GarageBlockedHourSearch) { }
}

export class GetGarageVisitList {
  static readonly type = '[Ald-Anonymous] Get Garage Visit List';
  constructor(public Search: GarageVisitsModels.GarageVisitsSearchModel) { }
}

export class GetGarageVisitPlaceList {
  static readonly type = '[Ald-Anonymous]  Get Garage Visit Place List';
  constructor(public Search: GarageVisitsModels.GarageVisitsPlaceSearch) { }
}

export class GetCarTypes {
  static readonly type = '[Ald-Anonymous] Get Car Types';
  constructor() { }
}

export class GetGarageVisit {
  static readonly type = '[Ald-Anonymous] GetGarageVisit';
  constructor(public GarageVisitId: Models.RequestModel) { }
}

export class GetVisitTyreSources {
  static readonly type = '[Ald-Anonymous] Visit Tyre Sources';
  constructor() { }
}

export class GetTyreDiameterList {
  static readonly type = '[Ald-Anonymous] GetTyreDiametersList';
  constructor() { }
}
